import axios from 'axios';

export const apiExecutor = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'access-control-allow-origins': '*',
  }
});
